import axios from "axios";
import authHeader from "./auth-header";
import AuthService from "./auth.service";
import { config } from "../config";

class TechnicalManagementService {
  getPartsToUse(date, users = []) {
    return axios
      .post(`${config["apiUrl"]}technical-management/parts-to-use`,
        { date: date, users: users },
        { headers: authHeader() },
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response.data);
        return null;
      });
  }

  getPatStatusControl(params) {
    const queryParams = Object.keys(params).reduce((acc, key) => {
      acc[encodeURIComponent(key)] = params[key];
      return acc;
    }, {});

    return axios
    .get(`${config["apiUrl"]}technical-management/pat-status-control`,
      { params: queryParams, headers: authHeader() },
    )
    .then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      if (error.response.status == 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("ERROR:: ", error.response.data);
      return null;
    });
  }

  confirmPatStatusControl(id) {
    return axios
    .post(`${config["apiUrl"]}technical-management/confirm-pat-status-control`,
      { id: id },
      { headers: authHeader() },
    )
    .then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      if (error.response.status == 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("ERROR:: ", error.response.data);
      return null;
    });
  }

  getPatDocumentationRequestedControl(params) {
    const queryParams = Object.keys(params).reduce((acc, key) => {
      acc[encodeURIComponent(key)] = params[key];
      return acc;
    }, {});

    return axios
    .get(`${config["apiUrl"]}technical-management/pat-documentation-requested-control`,
      { params: queryParams, headers: authHeader() },
    )
    .then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      if (error.response.status == 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("ERROR:: ", error.response.data);
      return null;
    });
  }

  confirmPatDocumentationRequestedControl(id) {
    return axios
    .post(`${config["apiUrl"]}technical-management/confirm-pat-documentation-requested-control`,
      { id: id },
      { headers: authHeader() },
    )
    .then((response) => {
      if (response.status == 200) {
        return response.data;
      }
      return null;
    })
    .catch((error) => {
      if (error.response.status == 401) {
        AuthService.logout();
        window.location = "/login";
      }
      console.log("ERROR:: ", error.response.data);
      return null;
    });
  }

  getCommercialOfferDispatches(params) {
    const queryParams = Object.keys(params).reduce((acc, key) => {
      acc[encodeURIComponent(key)] = params[key];
      return acc;
    }, {});

    return axios
      .get(`${config["apiUrl"]}technical-management/commercial-offer-dispatches`,
        { params: queryParams, headers: authHeader() },
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  getCommercialOfferDispatch(id) {
    return axios
      .get(`${config["apiUrl"]}technical-management/commercial-offer-dispatches/${id}`,
        { headers: authHeader() },
      )
      .then((response) => {
        if (response.status == 200) {
          return response.data;
        }
        return null;
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        console.log("ERROR:: ", error.response ? error.response.data : error);
        return null;
      });
  }

  expireCommercialOfferDispatch(id, reason = null) {
    return axios
      .post(`${config["apiUrl"]}technical-management/commercial-offer-dispatches/${id}/expire`,
        { reason: reason },
        { headers: authHeader() },
      )
      .then((response) => {
        return { status: response.status, data: response.data };
      })
      .catch((error) => {
        if (error.response && error.response.status == 401) {
          AuthService.logout();
          window.location = "/login";
        }
        return {
          status: error.response ? error.response.status : 500,
          data: error.response ? error.response.data : null,
        };
      });
  }
}
export default new TechnicalManagementService();
